export default __webpack_public_path__ + "static/videoIntro-1080-ea732d6279de5d4ad52b8999a5eaf46d.mp4";